import { render, staticRenderFns } from "./link-echarts.vue?vue&type=template&id=864d0476&"
import script from "./link-echarts.vue?vue&type=script&lang=js&"
export * from "./link-echarts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports